import { graphql } from '@/gql';
import type { CheckAndRecordShoppingPopupMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ShoppingPlace } from '@/models/caller';

export const checkAndRecordShoppingPopup = async ({
  phoneNumber,
  locations,
}: CheckAndRecordShoppingPopupMutationVariables): Promise<ShoppingPlace[]> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CheckAndRecordShoppingPopup($phoneNumber: String!, $locations: [CoordinatesInput!]!) {
        checkAndRecordShoppingPopup(phoneNumber: $phoneNumber, locations: $locations) {
          name
          type
          distance
          latitude
          longitude
        }
      }
    `),
    variables: {
      phoneNumber,
      locations,
    },
  });

  return response.data?.checkAndRecordShoppingPopup ?? [];
};
